import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as toastr from 'toastr'

import { City, Setor, State } from '@shared/models';
import { ConsultRequest } from '@shared/utils/consult-request';
import { ClientesService } from '@modules/clientes/services/clientes.service';

@Component({
  selector: 'app-cidade-combo',
  templateUrl: './cidade-combo.component.html',
  styleUrls: ['./cidade-combo.component.css']
})
export class CidadeComboComponent implements OnInit {

  @Input() cidade: City = null;
  @Output() cidadeChange = new EventEmitter<City>();

  @Input() vendedorSelecionado: {id: number, nome: string, setor: string, idSetor: number};

  _setor: Setor = null;
  _uf: State = null;

  @Input() required = false;
  @Input() disabled = false;

  citiesRequest = new ConsultRequest<City[]>();

  constructor(
    private clientService: ClientesService,
  ) {
  }

  get consultDisabled(){
    return !this.setor || !this.uf || this.citiesRequest.isLoading;
  }

  @Input()
  set setor(value: Setor | null){
    if(!value){
      this._setor = null;
    }else{
      this._setor = value;
    }

    this.getCities();
  }

  get setor(){
    return this._setor;
  }

  @Input()
  set uf(value: State | null){
    if(!value){
      this._uf = null;
    }else{
      this._uf = value;
    }

    this.getCities()
  }

  get uf(){
    return this._uf;
  }

  ngOnInit() {
  }

  handleCityChange(){
    this.cidadeChange.emit(this.cidade)
  }

  handleClick(event: MouseEvent){
    if(this.consultDisabled){
      if(this.citiesRequest.isLoading){
        event.preventDefault()
        toastr.error('A combo ainda está carregando, tente mais tarde')
        return;
      }

      event.preventDefault()
      toastr.error('Para selecionar a cidade, selecione a uf antes')
      return;
    }
  }

  // metodos privados

  private getCities() {
    this.reset();

    if(this.consultDisabled){
      return;
    }

    if(this.vendedorSelecionado!=null){
      this.citiesRequest.get(
        this.clientService.getCitiesWithSalesPerson(this.uf.idUf, this.setor.id, this.vendedorSelecionado.idSetor)
      )
    }else{
      this.citiesRequest.get(
        this.clientService.getCities(this.uf.idUf, this.setor.id)
      )
    }

  }

  private reset(){
    this.citiesRequest.reset()
    this.citiesRequest.cancel()
    this.cidade = null;
    setTimeout(()=>this.handleCityChange())
  }

}
